import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import ComingSoon from "./components/ComingSoon";

// Check if admin access is granted
const hasAdminAccess = () => {
  return localStorage.getItem("admin_access") === "true";
};

// Check if current path is admin route
const isAdminRoute = () => {
  return window.location.pathname.startsWith("/admin");
};

function App() {
  // Show coming soon page by default, unless admin access is granted or on admin route
  const showComingSoon = !hasAdminAccess() && !isAdminRoute();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Coming Soon Route (Default for public) */}
          <Route 
            path="/" 
            element={showComingSoon ? <ComingSoon /> : <HomePage />} 
          />
          
          {/* Admin Routes - Always accessible */}
          <Route path="/admin" element={<HomePage />} />
          <Route path="/admin/*" element={<HomePage />} />
          
          {/* Fallback - Show coming soon for any other routes if no admin access */}
          <Route 
            path="*" 
            element={showComingSoon ? <ComingSoon /> : <HomePage />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;